export const defaultStyle = {
  navContainer:
    "mobilemenuWrap flex flex-wrap justify-between absolute xl:static top-0 w-full h-[0] flex-row-reverse  left-0",
  navContent: "block ",
  navItems: "nav-items pb-0 pt-[25px] pl-0 mt-0 mb-[16px] box-border bg-white ",

  navToggle: "flex items-center   absolute h-[88px] z-[10] right-[15px] top-0 w-[26.78px] navTogg",
  navToggleIcon: "cursor-pointer",
  navgationItem: "",
  topNav: "",
  mobileStockPrice:
    "bg-darkgray text-white px-[25px] py-[17px] leading-[24px] text-[16px] border-t-[1px] border-white ",
}

export const MAIN_NAV_ITEM = {
  navContainer:
    "flex flex-wrap justify-between absolute lg:static top-0 w-full  flex-row-reverse z-9 left-0",

  navContent:
    "navContent absolute top-[153px] right-0 w-11/12 bg-green-700  z-9999 box-border",

  navItems:
    "nav-items pb-0 pt-[25px] pl-0 mt-0 mb-[16px] box-border  m-[16px]   ",
}

export const MAIN_NAV_SUBMENU_ITEM = {
  navContent: "bg-green-700",
}

export const MAIN_NAV_SUBMENU_LEVEL_2 = {
  navContainer:
    "flex flex-wrap justify-between absolute lg:static top-0 w-full  flex-row-reverse z-9 left-0",

  navContent:
    "navContent absolute top-[153px] right-0 w-11/12 bg-green-700  z-9999 box-border",

  navItems:
    "nav-items pb-0 pt-[25px] pl-0 mt-0 mb-[16px] box-border  m-[16px]   ",
}

export const TOP_NAV_ITEM = {
  navContainer:
    "flex flex-wrap justify-between absolute lg:static top-0 w-full  flex-row-reverse z-9 left-0",

  navContent:
    "navContent absolute top-[153px] right-0 w-11/12 bg-green-700  z-9999 box-border",

  navItems:
    "nav-items pb-0 pt-[25px] pl-0 mt-0 mb-[16px] box-border  m-[16px]   ",
}

export const TOP_NAV_SUBMENU_ITEM = {
  navContainer:
    "flex flex-wrap justify-between absolute lg:static top-0 w-full  flex-row-reverse z-9 left-0",

  navContent:
    "navContent absolute top-[153px] right-0 w-11/12 bg-green-700  z-9999 box-border",

  navItems:
    "nav-items pb-0 pt-[25px] pl-0 mt-0 mb-[16px] box-border  m-[16px]   ",
}

export const TOP_NAV_SUBMENU_LEVEL_2 = {
  navContainer:
    "flex flex-wrap justify-between absolute lg:static top-0 w-full  flex-row-reverse z-9 left-0",

  navContent:
    "navContent absolute top-[153px] right-0 w-11/12 bg-green-700  z-9999 box-border",

  navItems:
    "nav-items pb-0 pt-[25px] pl-0 mt-0 mb-[16px] box-border  m-[16px]   ",
}
